// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bracket-user-header {
  width: 1366px;
  height: 253px;
  display: flex;
  align-items: center;
  border-bottom: #FFC60A 9px solid;
  background: #F2F2F2;
}

.user-info .user-name {
  text-align: left;
  color: #002129;
  font-family: Inter;
  font-size: 40px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-bottom: 20px;
}

.user-stats {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex: 1 1;
}

.champ-box {
  height: 155px;
  border-right: 1px solid;
}

.champ-box .user-stat {
  padding-right: 25px;
  border-right: none;
  height: 32px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-bottom: 32px;
}

.user-stat {
  padding-right: 25px;
  border-right: 1px solid;
  height: 130px;
  width: 250px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-bottom: 20px;
}

.rank {
  width: 93px;
}

.user-stat.mix {
  width: 42%;
  border: none;
}

.tiebreaker-box {
  width: 185px;
  height: 85px;
  border-radius: var(--1, 8px) var(--1, 8px) var(--1, 8px) var(--1, 8px);
  border: 1px solid #6D6D6D;
  background: rgba(24, 24, 24, 0.1);
  margin: 0 auto;
}

.stat-value {
  color: #002129;
  text-align: center;
  font-family: Inter;
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.user-info {
  width: 100%;
  max-width: 900px;
}

.stat-heading {
  color: #002129;
  text-align: center;
  font-family: Inter;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  border-right: none;
}

.navBar {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  max-width: 500px;
  margin: 50px auto;
}
.navBar .navItem {
  cursor: pointer;
  color: #002129;
  font-family: Inter;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px; /* 100% */
  letter-spacing: 0.4px;
  text-transform: capitalize;
  padding-bottom: 10px;
}
.navBar .navItem.active {
  border-bottom: 3px solid #002129;
}
.navBar .navItem:hover {
  color: blue;
}
.navBar .activeNavItem {
  color: blue;
}`, "",{"version":3,"sources":["webpack://./src/components/bracketEvents/bracketStyles/bracketNav.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,gCAAA;EACA,mBAAA;AACJ;;AACA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;AAEJ;;AAAA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AAGJ;;AAAA;EACI,aAAA;EACA,uBAAA;AAGJ;;AAAA;EACI,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,oBAAA;AAGJ;;AAAA;EACI,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,oBAAA;AAGJ;;AADA;EACI,WAAA;AAIJ;;AADA;EAGI,UAAA;EACA,YAAA;AAEJ;;AACA;EACI,YAAA;EACA,YAAA;EACA,sEAAA;EACA,yBAAA;EACA,iCAAA;EACA,cAAA;AAEJ;;AACA;EACI,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAEJ;;AACA;EACI,WAAA;EACA,gBAAA;AAEJ;;AACA;EACI,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EAGA,kBAAA;AADJ;;AAGA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;AAIJ;AAFI;EACI,eAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;EACA,qBAAA;EACA,0BAAA;EACA,oBAAA;AAIR;AAFI;EACI,gCAAA;AAIR;AADI;EACI,WAAA;AAGR;AADI;EACI,WAAA;AAGR","sourcesContent":[".bracket-user-header{\n    width: 1366px;\n    height: 253px;\n    display:flex;\n    align-items: center;\n    border-bottom: #FFC60A 9px solid;\n    background: #F2F2F2;\n}\n.user-info .user-name{\n    text-align: left;\n    color: #002129;\n    font-family: Inter;\n    font-size: 40px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n    margin-bottom: 20px;\n}\n.user-stats{\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    flex:1;\n}\n\n.champ-box{\n    height: 155px;\n    border-right: 1px solid;\n}\n\n.champ-box .user-stat{\n    padding-right: 25px;\n    border-right: none;\n    height: 32px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    padding-bottom: 32px;\n}\n\n.user-stat{\n    padding-right: 25px;\n    border-right: 1px solid;\n    height: 130px;\n    width: 250px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    padding-bottom: 20px;\n}\n.rank{\n    width: 93px;\n}\n\n.user-stat.mix{\n    // display: flex;\n    // justify-content: space-around;\n    width: 42%;\n    border: none;\n}\n\n.tiebreaker-box{\n    width: 185px;\n    height: 85px;\n    border-radius: var(--1, 8px) var(--1, 8px) var(--1, 8px) var(--1, 8px);\n    border: 1px solid #6D6D6D;\n    background: rgba(24, 24, 24, 0.10);\n    margin: 0 auto;\n}\n\n.stat-value {\n    color: #002129;\n    text-align: center;\n    font-family: Inter;\n    font-size: 32px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n}\n\n.user-info{\n    width: 100%;\n    max-width: 900px;\n}\n\n.stat-heading{\n    color: #002129;\n    text-align: center;\n    font-family: Inter;\n    font-size: 24px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n}\n.stat-heading{\n    border-right:none;\n}\n.navBar {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    max-width: 500px;\n    margin: 50px auto;\n\n    .navItem {\n        cursor: pointer;\n        color: #002129;\n        font-family: Inter;\n        font-size: 24px;\n        font-style: normal;\n        font-weight: 700;\n        line-height: 24px; /* 100% */\n        letter-spacing: 0.4px;\n        text-transform: capitalize;\n        padding-bottom: 10px;\n    }\n    .navItem.active{\n        border-bottom:3px solid #002129;\n    }\n\n    .navItem:hover {\n        color: blue;\n    }\n    .activeNavItem {\n        color: blue;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
